import { Section } from '../../grid-system/section/section';
import { MyContent } from '../my-content/my-content';

/**
 * Renderer for the `atos/my-content` Gutenberg block — i.e. the editor-authored
 * "My content" page that used to be the canonical bookmarks landing page (its
 * URL was sourced from the WP `my_content_page` general option).
 *
 * The frontend no longer links here: the header / mobile menu / profile sidebar
 * all navigate to the hardcoded /my-account/bookmarks route (see `userProfileUrls`
 * on AppContext). We keep this component because production sites may still
 * have an editor-authored page using this block, possibly linked from menus,
 * footers, or third-party emails — removing it would 404 those links.
 *
 * Future cleanup: once we've audited prod and confirmed nothing links here,
 * either delete this component (and the `atos/my-content` block + the entry in
 * component-map.tsx) or have it server-side redirect to userProfileUrls.bookmarks
 * so any stale links land in the right place.
 */
export const MyContentPage = () => {
    return (
        <Section templateShorthand={[12]} widthType="bgFull">
            <div>
                <MyContent filterBgColor='white' />
            </div>
        </Section>
    );
};

